import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHappycowComponent } from './simple-icons-happycow.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHappycowComponent ],
    exports:      [ SimpleIconsHappycowComponent ],
    bootstrap:    []
})
export class SimpleIconsHappycowModule {}
